import React from 'react';

export const Address = ({ address }) => {
  const { street1, street2, city, state, zip } = address;
  return (
    <div className="blocked_data">
      <div> {street1} </div>
      {street2 ? <div> {street2} </div> : null}
      <div>
        {' '}
        {city}, {state} {zip}
      </div>
    </div>
  );
};
